var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_76298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58173 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08173 16 0.5 12.4183 0.5 8ZM8.5 1.14286C4.71291 1.14286 1.64286 4.21291 1.64286 8C1.64286 11.7871 4.7129 14.8571 8.5 14.8571C12.2872 14.8571 15.3571 11.7872 15.3571 8C15.3571 4.2129 12.2871 1.14286 8.5 1.14286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57562 8.59228C4.87969 8.50781 5.19467 8.68585 5.27914 8.98992C5.76203 10.7283 7.71334 11.8154 9.46858 11.341C10.5628 10.9358 11.4336 10.043 11.7201 8.99251C11.8032 8.68804 12.1173 8.50853 12.4218 8.59157C12.7262 8.67461 12.9057 8.98874 12.8227 9.29322C12.4253 10.7503 11.2483 11.91 9.83812 12.4227C9.82419 12.4278 9.81007 12.4323 9.79578 12.4363C7.44222 13.0901 4.83598 11.6646 4.17797 9.2958C4.09351 8.99172 4.27154 8.67675 4.57562 8.59228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48066 5.94308C6.52928 5.85903 6.55711 5.76145 6.55711 5.65737C6.55711 5.34177 6.30127 5.08594 5.98568 5.08594C5.5123 5.08594 5.12854 5.46969 5.12854 5.94308C5.12854 6.41647 5.5123 6.80022 5.98568 6.80022C6.30127 6.80022 6.55711 6.54439 6.55711 6.22879C6.55711 6.12471 6.52928 6.02713 6.48066 5.94308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41431 5.65737C5.41431 5.34177 5.67014 5.08594 5.98574 5.08594C6.45912 5.08594 6.84288 5.46969 6.84288 5.94308C6.84288 6.41647 6.45912 6.80022 5.98574 6.80022C5.67014 6.80022 5.41431 6.54439 5.41431 6.22879C5.41431 6.12471 5.44213 6.02713 5.49075 5.94308C5.44213 5.85903 5.41431 5.76145 5.41431 5.65737Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5092 5.94308C11.5578 5.85903 11.5857 5.76145 11.5857 5.65737C11.5857 5.34177 11.3298 5.08594 11.0142 5.08594C10.5409 5.08594 10.1571 5.46969 10.1571 5.94308C10.1571 6.41647 10.5409 6.80022 11.0142 6.80022C11.3298 6.80022 11.5857 6.54439 11.5857 6.22879C11.5857 6.12471 11.5578 6.02713 11.5092 5.94308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4429 5.65737C10.4429 5.34177 10.6987 5.08594 11.0143 5.08594C11.4877 5.08594 11.8714 5.46969 11.8714 5.94308C11.8714 6.41647 11.4877 6.80022 11.0143 6.80022C10.6987 6.80022 10.4429 6.54439 10.4429 6.22879C10.4429 6.12471 10.4707 6.02713 10.5193 5.94308C10.4707 5.85903 10.4429 5.76145 10.4429 5.65737Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_76298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSmiley);
export default __webpack_public_path__ + "static/media/face-smiley.8e98fa6d14d99538524f41380427103f.svg";
export { ForwardRef as ReactComponent };